<template>
  <div class="m-input-box">
    <div class="mImport">
      <span class="label" v-if="label">{{label}}</span>
      <van-radio-group class="m-rads" v-model="inputModel" @change="$emit('input',inputModel)">
        <van-radio class="m-rad" v-for="item in radioList" :name="item.code">{{item.name}}</van-radio>
        <!--<van-radio class="m-rad" name="male">男</van-radio>-->
        <!--<van-radio class="m-rad" name="female">女</van-radio>-->
      </van-radio-group>
      <!--<span class="unit" v-if="unit">{{unit}}</span>-->
    </div>
    <span class="error" :class="{ hasLabel:label }" v-if="errors()"><span class="icon icon-note"></span>{{validationErrors}}</span>
  </div>
</template>

<script>

import { RadioGroup, Radio } from 'vant'
import Vue from 'vue'

Vue.use(RadioGroup).use(Radio)

export default {
  props: {
    value: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: '请输入'
    },
    label: {
      type: String,
      default: ''
    },
    radioList: {
      type: Array,
      default: []
    }
  },
  data () {
    return {
      error: '',
      das: 0,
      submitOld: this.$validation,
      inputModel: this.value,
      validationErrors: null,
      modelExpression: this.$options._parentVnode.data.model.expression
    }
  },
  inject: ['$validation'],
  watch: {
    'value' (newV, oldV) {
      this.inputModel = newV
    }
    //      'inputModel' (newV,oldV){//        this.$validation.validate
    //        this.$nextTick(()=>{
    //          this.validationErrors = this.$validation.validAll(this.modelExpression)
    //        })
    //      },
    //      'submitOld.submit' (newV,oldV) {
    //        if(newV){
    //          this.validationErrors=this.$validation.validAll(this.modelExpression)
    //        }
    //      }
  },
  mounted () {
    this.$root.$on('showErr', (obj) => {
      this.errors()
    })
  },
  methods: {
    errors () {
      if (this.value === this.inputModel) {
        this.validationErrors = this.$validation.error(this.modelExpression)
        return this.validationErrors
      }
    }
  }
}
</script>
<style ref="stylesheet/scss" lang="scss" scoped>
  @import "@/assets/style/variables.scss";
  .m-rad/deep/ .van-radio__icon--checked .van-icon {
    background-color: $assertive !important;
    border-color: $assertive !important;
  }
  .m-input-box {
    background: $light;
    padding: 0 15px !important;
    color: $dark;
    font-size: 16px;
    border-bottom: 1px solid #f5f5f5;
  }
    .van-radio-group{
      display: flex;
      width: 100%;
    }
    .m-rads /deep/ .van-radio__label{
      position: relative;
      top: -2px;
    }

    .van-radio{
      flex: 0 30% !important;
    }
  .label {
    flex: 0 0 80px;
    font-size: 17px;
  }
  .hasLabel{
    padding-left: 70px;
  }
  .mImport {
    align-items: center;
    height: 50px;
    display: flex;
    /*flex: 1;*/
  }
  input {
    border: none;
    width: 100%;
  }

  .error{
    color: #f25930;
    display: inline-block;
    padding-bottom: 10px;
  }
  .unit{
    flex: 0 0 auto;
  }
</style>
